import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { connect } from 'react-redux';
import { patchPOLineItem } from '../../thunks/purchase_order_line_items_thunks';

const FORM_NAME = 'update-gl-code-form';

const EditPOLiGLCodeModal: FC<any> = ({
	purchaseOrderLineItem,
	updateGLCode,
	onSuccess,
	onCancel,
}) => {
	const [saving, setSaving] = useState(false);

	const onSubmit = useCallback(
		(values) => {
			setSaving(true);
			updateGLCode(purchaseOrderLineItem, {
				...values,
			}).finally(() => {
				setSaving(false);
				onSuccess && onSuccess();
			});
		},
		[onSuccess, purchaseOrderLineItem, updateGLCode]
	);

	const initialValues = useMemo(
		() => ({
			...purchaseOrderLineItem,
		}),
		[purchaseOrderLineItem]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={`Update GL Code`}
			closable
			onCancel={onCancel}
			forceRender
			footer={[
				<Button onClick={onCancel} size="large">
					Cancel
				</Button>,
				<Button
					type="primary"
					size="large"
					style={{ marginLeft: '16px' }}
					key="submit"
					htmlType="submit"
					form={FORM_NAME}
					loading={saving}
				>
					{'Update'}
				</Button>,
			]}
		>
			<Form
				id={FORM_NAME}
				layout="vertical"
				requiredMark={false}
				initialValues={initialValues}
				onFinish={onSubmit}
			>
				<Form.Item name="glCode" label="GL Code">
					<Input style={{ width: '100%' }} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	updateGLCode: (entity, data) => dispatch(patchPOLineItem(entity, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPOLiGLCodeModal);
